import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeftRight } from "lucide-react";
import { useSyncMode } from "./useSyncMode";

export const timeAgo = (iso) => {
    if (!iso) return "never";
    const s = Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 1000));
    if (s < 60) return `${s}s ago`;
    if (s < 3600) return `${Math.round(s / 60)} min ago`;
    if (s < 86400) return `${Math.round(s / 3600)} h ago`;
    return `${Math.round(s / 86400)} d ago`;
};

/** Slim persistent banner on Radar pages of a spoke (replica or linked standalone). Renders nothing on the hub / unlinked. */
export function ReplicaBanner() {
    const { info } = useSyncMode();
    if (!info?.spoke) return null;
    const stale = info.last_error || (info.last_sync_at && Date.now() - new Date(info.last_sync_at).getTime() > 15 * 60 * 1000);
    return (
        <div
            className={`mb-4 flex flex-wrap items-center gap-x-3 gap-y-1 rounded border px-3 py-2 text-xs ${stale ? "border-amber-400/40 bg-amber-400/10 text-amber-100" : "border-sky-400/30 bg-sky-400/5 text-sky-100"}`}
            data-testid="replica-banner"
        >
            <ArrowLeftRight className="w-3.5 h-3.5" />
            <span className="font-medium" data-testid="replica-banner-hub">Two-way sync with {info.hub_url || "hub"}</span>
            <span className="text-white/40">·</span>
            <span data-testid="replica-banner-channel">channel {info.channel || "—"}</span>
            <span className="text-white/40">·</span>
            <span data-testid="replica-banner-synced">synced {timeAgo(info.last_sync_at)}</span>
            {info.lag > 0 && <span className="text-white/60" data-testid="replica-banner-lag">· {info.lag.toLocaleString()} changes behind</span>}
            {info.in_sync === false && <span className="text-amber-200" data-testid="replica-banner-drift">· last check found drift</span>}
            {info.last_error && <span className="text-amber-200" data-testid="replica-banner-error">· last sync failed</span>}
            <span className="ml-auto">
                Hub wins on conflict ·{" "}
                <Link to="/settings/radar-sync" className="underline hover:text-white" data-testid="replica-banner-link">Sync status</Link>
            </span>
        </div>
    );
}
